import { render, staticRenderFns } from "./SipCacheStatistics.vue?vue&type=template&id=d2700ab0&scoped=true"
import script from "./SipCacheStatistics.vue?vue&type=script&lang=js"
export * from "./SipCacheStatistics.vue?vue&type=script&lang=js"
import style0 from "./SipCacheStatistics.vue?vue&type=style&index=0&id=d2700ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2700ab0",
  null
  
)

export default component.exports